import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import {
  getAllPriceProductProfile,
  getSelectTypeColor,
  updatePriceProductGlassGroup,
} from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import { toggleNChangeType, toggleNPercentRiyal } from "Constants/Constants";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

let _toggleNChangeType = toggleNChangeType;

function ChangeGroupPrice() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    dasteProfileList,
    typeColorList,
    selectedDasteProfile,
    selectedTypeColor,
    priceProfileDataPagination,
  } = useSelector((state) => ({
    dasteProfileList: state.profile.dasteProfileList,
    typeColorList: state.profile.typeColorList,
    selectedDasteProfile: state.profile.selectedDasteProfile,
    selectedTypeColor: state.profile.selectedTypeColor,
    priceProfileDataPagination: state.profile.priceProfileDataPagination,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [controls, setControls] = useSetState({
    profileSeries: {
      type: "select",
      row: 1,
      selectItems: [],
      value: "",
      col: {
        sm: 12,
        xs: 12,
      },
      validation: {
        required: true,
      },
    },
    profileTypeColor: {
      type: "select",
      row: 1,
      selectItems: [],
      value: "",
      col: {
        sm: 12,
        xs: 12,
      },
      validation: {
        required: true,
      },
    },
    price: {
      type: "price",
      row: 1,
      value: "",
      col: {
        sm: 12,
        xs: 12,
      },
      validation: {
        required: true,
        isPrice: true,
      },
      relation: "isPercent",
    },
    isPercent: {
      type: "toggle",
      row: 2,
      relation: "price",
      arrayItems: toggleNPercentRiyal,
      value: toggleNPercentRiyal[0],
      col: {
        sm: 4,
        xs: 6,
      },
      ValidationPlus: {
        isPercent: true,
      },
      validation: {
        required: true,
      },
    },
    changeType: {
      type: "toggle",
      row: 1,
      arrayItems: [],
      value: null,
      col: {
        sm: 12,
        xs: 12,
      },
      validation: {
        required: true,
      },
    },
  });

  const onEnter = () => {
    onClear();
  };

  const onClear = () => {
    setFormValid({ price: false });
    setCheckValid(false);
    setControls({ price: { value: "" } });
    setControls({ isPercent: { value: toggleNPercentRiyal[0] } });
    _toggleNChangeType[0].disabled = true;
    setControls({
      changeType: {
        arrayItems: _toggleNChangeType,
        value: _toggleNChangeType[1],
      },
    });
    setControls({
      profileSeries: {
        selectItems: dasteProfileList,
        value: dasteProfileList[0],
      },
    });
    getProfileTypeColor(dasteProfileList[0].Id);
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "profileSeries") getProfileTypeColor(value.Id);
  };

  const getProfileTypeColor = async (id) => {
    const data = await dispatch(getSelectTypeColor(id));
    if (data) {
      setControls({
        profileTypeColor: {
          selectItems: data,
          value: data[0],
        },
      });
    } else {
      setControls({
        profileTypeColor: {
          selectItems: [],
          value: "",
        },
      });
    }
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  useEffect(() => {
    try {
      _toggleNChangeType[0].disabled = controls.isPercent.value.value;
      let _value = controls.changeType.value;
      if (
        controls.isPercent.value.value &&
        _value.value === _toggleNChangeType[0].value
      )
        _value = _toggleNChangeType[1];
      setControls({
        changeType: { arrayItems: _toggleNChangeType, value: _value },
      });
    } catch {
      _toggleNChangeType[0].disabled = false;
      setControls({
        changeType: {
          arrayItems: _toggleNChangeType,
          value: _toggleNChangeType[1],
        },
      });
    }
  }, [controls.isPercent?.value?.value]);

  const handleDialog = () => setOpenDialog(!openDialog);

  const onFinish = async (e) => {
    e.preventDefault();
    const { profileTypeColor, profileSeries, price, isPercent, changeType } =
      controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true) &&
      profileTypeColor.value !== "" &&
      profileSeries.value !== "" &&
      price.value !== ""
    ) {
      if (isPercent.value.value && price.value > 100) {
        showNotify({
          text: t("wrongPercentage"),
          customClass: "error",
        });
      } else {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IsPercent: isPercent.value.value,
            IdColor: profileTypeColor.value.IdColor,
            Value: +price.value,
            IdSeri: profileSeries.value.Id,
            IdTypeColor: profileTypeColor.value.IdTypeColor,
            TypeAction: +changeType.value.value,
          };
          await dispatch(updatePriceProductGlassGroup(data));
          if (profileSeries.value.Id === selectedDasteProfile.Id) {
            const paramsPrice = {
              KeyUser: read("userKey"),
              KeyGroup: read("groupKey"),
              IdGroupProfile: Number(selectedDasteProfile.Id),
              IdTypeColor: Number(selectedTypeColor.IdTypeColor),
              IdColor: Number(selectedTypeColor.IdColor),
              Limit: priceProfileDataPagination.Limit,
              Page: priceProfileDataPagination.Page,
            };
            await dispatch(getAllPriceProductProfile(paramsPrice));
          }
          setLoading(false);
        } catch (e) {
          showNotify({
            text: t("correctFormDataRequired"),
            customClass: "error",
          });
          setLoading(false);
        }
      }
    } else {
      showNotify({
        text: t("checkAllFields"),
        customClass: "warning",
      });
      setCheckValid(true);
    }
  };

  const onExit = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"priceChangeInGroup"} />}
        onClick={handleDialog}
        disabled={selectedDasteProfile?.Disable}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{
          onEnter: onEnter,
          onExit: onExit,
        }}
        fullWidth
        maxWidth="xs"
        onClose={handleDialog}
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"priceChangeInGroup"} />}</p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              {Object.keys(controls)
                .filter((key) => controls[key].row === 1)
                .map((key, index) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key + index}
                    >
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          loading={loading}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                        />
                      )}
                      {controls[key].type === "price" && (
                        <Input
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          name={key}
                          placeholder={t(key)}
                          validation={
                            controls[key].relation &&
                            controls[controls[key].relation].value.value
                              ? {
                                  ...controls[key].validation,
                                  ...controls[controls[key].relation]
                                    .ValidationPlus,
                                }
                              : controls[key].validation
                          }
                          checkValid={checkValid}
                          label={<Translator id={key} />}
                          type={controls[key].type}
                          endIcon={
                            controls[controls[key].relation].value.value ? (
                              "%"
                            ) : (
                              <Translator id="moneyUnit" />
                            )
                          }
                          radioGroup={{
                            name: controls[key].relation,
                            value: controls[controls[key].relation].value,
                            items: controls[controls[key].relation].arrayItems,
                            onChange: onChangeToggle,
                          }}
                        />
                      )}
                      {controls[key].type === "toggle" && (
                        <MuiRadioGroup
                          name={key}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          items={controls[key].arrayItems}
                          onChange={onChangeToggle}
                          translate={true}
                          className="horizontalRadio"
                        />
                      )}
                    </Grid>
                  );
                })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default ChangeGroupPrice;
